import Image from "next/image";
import Layout from "@/components/layout";
import styles from "@/styles/ServicesDetail.module.css";
import { useRouter } from "next/router";
import { Container, Row, Col, Accordion, Button } from "react-bootstrap";
import { useState, useRef, useEffect } from "react";
import Link from "next/link";

const ReikiDetail = () => {
  const router = useRouter();
  const [next, setNext] = useState(false);
  const [showSideButton, setShowSideButton] = useState(false);
  const firstSectionRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!firstSectionRef.current) return;

      const sectionTop = firstSectionRef.current.getBoundingClientRect().bottom;

      setShowSideButton(sectionTop < 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <section
        className={`${styles["section-banner"]} "banner-page"`}
        style={{
          background: "url(/images/reikiHealing-serviceDetail-Banner.png)",
        }}
        ref={firstSectionRef}
      >
        <Container>
          <Row>
            <Col md={8} className="m-auto">
              <div className={styles["inner-content"]}>
                <h1 className={styles["banner-title"]}>
                  Welcome to our Reiki Healing Service!
                </h1>
                <p>
                  At Zenkify, we believe in the power of energy healing and its
                  ability to restore balance and harmony within the body, mind,
                  and spirit. Our{" "}
                  <Link
                    href="/services/reiki-healing"
                    style={{ color: "white" }}
                  >
                    {" "}
                    Reiki Healing Services in USA
                  </Link>{" "}
                  offers a holistic approach to well-being, aiming to support
                  your overall health and wellness.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section
        className={styles["content-grid"] + " " + styles["section-content"]}
      >
        <Container>
          <Row>
            <Col
              lg={7}
              className="me-auto align-self-center order-lg-1 order-2"
            >
              <div className={styles["inner-content"]}>
                <h2>About Reiki Healing</h2>
                <p>
                  Reiki is a holistic healing practice that originated in Japan
                  in the early 20th century. It is based on the concept of
                  channeling universal life energy to promote balance,
                  relaxation, and healing. Reiki is a form of energy healing
                  that focuses on the flow of life force energy, also known as
                  &quot;ki&quot; or &quot;qi.&quot; Practitioners believe that
                  disruptions or imbalances in this energy can lead to physical,
                  emotional, or spiritual ailments. Reiki aims to restore
                  harmony and facilitate the body&apos;s natural healing
                  abilities.
                </p>
              </div>
            </Col>
            <Col lg={4} className="order-lg-2 order-1">
              <div className={styles["image"]}>
                <Image
                  width={400}
                  height={375}
                  src="/images/reiki-healing-service.svg"
                  alt="Reiki Healing Service"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section
        className={`${styles["content-grid"]} ${styles["working-section"]}`}
      >
        <Image
          width={150}
          height={101}
          src="/images/flower-shap-3.svg"
          className={styles["flower-top"]}
          alt="flower-shap"
        />
        <Image
          width={100}
          height={101}
          src="/images/flower-2.svg"
          className={styles["flower-right"]}
          alt="flower-shap"
        />
        <Container>
          <Row>
            <Col lg={4}>
              <Image
                width={420}
                height={485}
                src="/images/banner-slider-2.png"
                className={styles["reikiwork-image"]}
                alt="Reiki Healing Service"
              />
            </Col>
            <Col lg={8} className="ms-auto align-self-center ps-md-5">
              <div className={styles["inner-content"] + " " + "pe-0"}>
                <h3>How does Reiki work?</h3>
                <p>
                  Reiki works by harnessing universal life energy and
                  channelling it through a practitioner&apos;s hands into the
                  recipient&apos;s body. This gentle touch or proximity aims to
                  remove energy blockages, restoring balance within the
                  recipient&apos;s energy field. This process is believed to
                  facilitate relaxation, alleviate physical and emotional
                  distress, and stimulate the body&apos;s innate healing
                  abilities. While the scientific basis may be debated, Reiki is
                  embraced for its calming and healing effects on physical,
                  emotional, and spiritual well-being.
                </p>
                <ul>
                  <li>Universal Life Energy</li>
                  <li>Practitioner&apos;s Channeling</li>
                  <li>Energy Blockage Removal</li>
                  <li>Balance Restoration</li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
        <Image
          width={79}
          height={130}
          src="/images/flower-shap-2.svg"
          className={styles["flower-bottom"]}
          alt="flower-shap"
        />
      </section>
      <section className={styles["benefits-service"]}>
        <Container>
          <Row>
            <Col lg={8} className="m-auto pb-4">
              <div className="section-title">
                <h3 className="title">Benefits of Reiki Healing</h3>
                <p>
                  Reiki yields multiple benefits, including stress reduction,
                  pain alleviation, emotional equilibrium, and enhanced overall
                  well-being. By channeling universal life energy, it dispels
                  energy blockages, enhances relaxation, and activates the
                  body&apos;s self-healing capabilities, complementing
                  conventional treatments for holistic health improvement.
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={4} md={6} className="mb-4">
              <div className={styles["card-benefits"]}>
                <h4>Stress reduction</h4>
                <p>
                  Reiki promotes deep relaxation, easing tension and stress by
                  balancing the body&apos;s energy flow. This newfound
                  tranquility often extends to improved sleep and mental
                  clarity.
                </p>
              </div>
            </Col>
            <Col lg={4} md={6} className="mb-4">
              <div className={styles["card-benefits"]}>
                <h4>Emotional healing</h4>
                <p>
                  Reiki helps release stored emotional blockages, offering
                  solace from anxiety, depression, and emotional trauma,
                  fostering emotional resilience.
                </p>
              </div>
            </Col>
            <Col lg={4} md={6} className="mb-4">
              <div className={styles["card-benefits"]}>
                <h4>Pain management</h4>
                <p>
                  Many find relief from chronic pain conditions with Reiki. By
                  addressing energetic imbalances, it can complement traditional
                  pain management strategies.
                </p>
              </div>
            </Col>
            <Col lg={4} md={6} className="mb-4">
              <div className={styles["card-benefits"]}>
                <h4>Enhanced Immunity</h4>
                <p>
                  By optimizing the body&apos;s energy, Reiki may support the
                  immune system, helping to prevent illness and boost overall
                  health.
                </p>
              </div>
            </Col>
            <Col lg={4} md={6} className="mb-4">
              <div className={styles["card-benefits"]}>
                <h4>Spiritual Growth</h4>
                <p>
                  Reiki can facilitate spiritual exploration, deepening
                  one&apos;s connection to their inner self and the universe,
                  promoting a sense of purpose and meaning.
                </p>
              </div>
            </Col>
            <Col lg={4} md={6} className="mb-4">
              <div className={styles["card-benefits"]}>
                <h4>Improved Well-being</h4>
                <p>
                  Overall, Reiki contributes to a heightened sense of
                  well-being, restoring balance on physical, emotional, and
                  spiritual levels, allowing individuals to lead more fulfilled
                  lives.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
        <Image
          width={100}
          height={128}
          src="/images/stone-icon.svg"
          className={styles["stone-image"]}
          alt="flower"
        />
      </section>
      <hr />
      <section className={styles["service-section"]}>
        <Container>
          <Row>
            <Col md={4} className="mb-md-0 mb-2">
              <div className={styles["service-image"]}>
                <Image
                  width={420}
                  height={325}
                  src="/images/renki-healing-1.png"
                  alt="renki healing"
                />
              </div>
            </Col>
            <Col md={4} className="mb-md-0 mb-2">
              <div className={styles["service-image"]}>
                <Image
                  width={420}
                  height={325}
                  src="/images/renki-healing-2.png"
                  alt="renki healing"
                />
              </div>
            </Col>
            <Col md={4}>
              <div className={styles["service-image"]}>
                <Image
                  width={420}
                  height={325}
                  src="/images/renki-healing-3.png"
                  alt="renki healing"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="faq-section">
        <Container>
          <Row>
            <Col lg={10} className="m-auto">
              <div className="section-title">
                <h3 className="title">FAQ’s</h3>
                <p>
                  Get Answers to your Questions.Learn and Discover Energy
                  Healing Benefits, Sessions, Techniques, and more. Clear your
                  Doubts and make an Informed Choice. Explore Energy Healing
                  with our FAQs.
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={10} className="m-auto">
              <Accordion
                defaultActiveKey="0"
                className="faq-accordion"
                id="accordionExample"
              >
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    <span>
                      What is Reiki Therapy, and how does Zenkify offer it?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      {" "}
                      Reiki therapy is a Japanese method for reducing stress and
                      promoting relaxation, which involves energy work to
                      improve well-being. Zenkify provides Reiki therapy
                      services in the USA, offering knowledgeable healers who
                      aim to enhance overall health and vitality by healing the
                      body, mind, and soul.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    <span>
                      What are the benefits of Reiki Therapy provided by
                      Zenkify?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Benefits of Zenkify&apos;s Reiki Therapy in the USA
                      include emotional blockage release, anxiety, sadness, and
                      emotional trauma reduction, as well as emotional
                      resilience and pain management.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    <span>
                      How can I book Reiki Therapy Services with Zenkify?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Zenkify offers direct phone, internet, or in-person
                      booking for Reiki healing therapy in the USA. By Signup on
                      the Zenkify Platform, Users seeking Reiki Therapy can book
                      a slot with the Reiki Healers online.{" "}
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    <span>
                      What should I expect during a Reiki Therapy session with
                      Zenkify?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      During a Reiki Therapy session with Zenkify, you can
                      expect a gentle and relaxing experience aimed at restoring
                      balance within your energy field. The practitioner will
                      use their hands to channel universal life energy into your
                      body, aiming to remove energy blockages and promote
                      healing.
                    </p>
                    <p>
                      This process often induces a deep sense of relaxation and
                      may help alleviate both physical and emotional distress.
                      While the scientific underpinnings of Reiki may be subject
                      to debate, many people embrace it for its calming and
                      healing effects on various aspects of well-being,
                      including the physical, emotional, and spiritual realms.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    <span>
                      Are Zenkify&apos;s Reiki Therapy Services suitable for
                      everyone?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Zenkify&apos;s Reiki Therapy Services in the USA are
                      suitable for everyone, including babies, children,
                      pregnant women, and adults. Reiki creates a soothing and
                      comforting environment for the whole family.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="5">
                  <Accordion.Header>
                    <span>
                      How long does a typical Reiki Therapy session at Zenkify
                      last?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      A typical Reiki Therapy in the USA at Zenkify lasts around
                      50 minutes, during which the practitioner&apos;s hands are
                      placed on or slightly above the body through different
                      positions from head to toe.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="6">
                  <Accordion.Header>
                    <span>
                      Can Reiki Therapy from Zenkify help with specific health
                      conditions?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Yes, Zenkify&apos;s Reiki Therapy services in the USA can
                      assist with a wide range of health conditions, such as
                      pain, anxiety, depression, emotional trauma, and more. Its
                      goal is to promote healing and well-being in individuals.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="7">
                  <Accordion.Header>
                    <span>
                      Is it possible to receive reiki healing from a distance?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Absolutely! Numerous practitioners on this platform
                      provide remote or distance healing sessions. Reiki healing
                      remains equally potent when conducted remotely, as energy
                      surpasses physical limitations.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="8">
                  <Accordion.Header>
                    <span>
                      What qualifications do the practitioners at Zenkify have
                      to offer Reiki Therapy?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      The practitioners at Zenkify offering Reiki Therapy
                      Services in the USA are experienced and certified in this
                      energy healing modality, ensuring that clients receive
                      professional and effective treatment.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="9">
                  <Accordion.Header>
                    <span>
                      How frequently should I schedule Reiki Therapy sessions
                      with Zenkify for optimal results?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      The optimal frequency for scheduling Reiki Therapy
                      sessions with Zenkify varies depending on individual needs
                      and circumstances. It&apos;s recommended to consult with
                      the healers listed on the Zenkify platform to determine
                      the most suitable session schedule for your specific
                      situation. Factors such as your health goals, the severity
                      of your concerns, and how you respond to the therapy will
                      all influence the recommended frequency.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                {next == false ? (
                  <div className="text-center ">
                    <Button
                      className="theme-btn text-align-center my-4"
                      onClick={() => setNext(true)}
                    >
                      View more
                    </Button>
                  </div>
                ) : (
                  <>
                    <Accordion.Item eventKey="10">
                      <Accordion.Header>
                        <span>
                          What sets Zenkify&apos;s Reiki Therapy Services apart
                          from other providers?
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          Zenkify&apos;s Reiki Therapy Services stand out from
                          other providers for several reasons:
                        </p>
                        <strong></strong>
                        <p>
                          <strong>Expert Healers: </strong>Zenkify carefully
                          selects experienced and highly skilled Reiki
                          practitioners who are dedicated to their craft.
                        </p>
                        <p>
                          <strong>Personalized Approach: </strong>The healers on
                          Zenkify tailor each Reiki session to meet the unique
                          needs of the individual. Whether you&apos;re seeking
                          emotional healing, stress relief, or physical
                          wellness, the therapists will customize the session to
                          address your specific concerns.
                        </p>
                        <p>
                          <strong>Convenience: </strong>Zenkify offers
                          flexibility in scheduling sessions, making it
                          convenient for clients to find time for their Reiki
                          therapy amidst busy schedules. This accessibility
                          ensures that clients can prioritize their well-being
                          without added stress.
                        </p>
                        <p>
                          <strong>Holistic Perspective: </strong>Zenkify
                          embraces a holistic approach to healing, recognizing
                          the interconnectedness of mind, body, and spirit.
                          Reiki therapy at Zenkify goes beyond symptom
                          management to promote overall wellness and balance.
                        </p>
                        <p>
                          Overall, Zenkify&apos;s Reiki Therapy Services combine
                          expertise, personalization, convenience, holistic
                          principles, and community support to offer a
                          transformative healing experience that sets them apart
                          from other providers.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="11">
                      <Accordion.Header>
                        <span>
                          Can I combine Reiki Therapy with other treatments or
                          therapies offered by Zenkify?
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          Yes, you can combine Reiki Healing Therapy in the USA
                          with other treatments and therapies Zenkify provides,
                          such as massage, acupuncture, and more. Reiki works
                          harmoniously with different forms of treatment to
                          enhance overall well-being.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="12">
                      <Accordion.Header>
                        <span>
                          What safety measures does Zenkify have in place for
                          Reiki Therapy sessions?
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          At Zenkify, ensuring the safety and well-being of our
                          clients during Reiki Therapy sessions is paramount. We
                          have implemented several safety measures to provide a
                          secure and comfortable environment:
                        </p>
                        <p>
                          <strong>Qualified Practitioners: </strong>Zenkify
                          carefully selects Reiki practitioners who are
                          certified and experienced in providing safe and
                          effective therapy sessions.
                        </p>
                        <p>
                          <strong>Client Screening: </strong>Prior to sessions,
                          we conduct thorough screenings to understand
                          client&apos;s medical history, allergies, and any
                          specific concerns to ensure a tailored and safe
                          experience.
                        </p>
                        <p>
                          <strong>Informed Consent: </strong>We prioritize
                          informed consent, ensuring that clients understand the
                          nature of Reiki therapy, its potential effects, and
                          any associated risks before proceeding with sessions.
                        </p>
                        <p>
                          <strong>Confidentiality: </strong>Zenkify upholds
                          strict confidentiality standards to protect
                          client&apos;s privacy and sensitive information shared
                          during sessions.
                        </p>
                        <p>
                          <strong>Client Comfort: </strong>We prioritize client
                          comfort throughout the session, encouraging open
                          communication and feedback to address any discomfort
                          or concerns promptly.
                        </p>
                        <p>
                          <strong>Emergency Preparedness: </strong>Our
                          practitioners are trained to handle unexpected
                          situations or emergencies that may arise during
                          sessions, ensuring swift and appropriate responses.
                        </p>
                        <p>
                          By implementing these safety measures, Zenkify aims to
                          provide clients with a secure and supportive
                          environment for Reiki Therapy sessions, promoting
                          holistic healing and well-being.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="13">
                      <Accordion.Header>
                        <span>
                          Are there any contraindications for receiving Reiki
                          Therapy from Zenkify?
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          There are no known contraindications for receiving
                          Reiki Therapy Services in the USA from Zenkify.
                          However, it&apos;s advisable to consult with your
                          healthcare provider before starting any new therapy,
                          including Reiki, especially if you have specific
                          health concerns.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="14">
                      <Accordion.Header>
                        <span>
                          How can I prepare for a Reiki Therapy session with
                          Zenkify?
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          To prepare for a Reiki Therapy session at Zenkify, you
                          can avoid alcohol and caffeine for 1-3 days, practice
                          meditation, and focus on releasing negative emotions.
                          Drinking extra water before and after the session is
                          recommended for detoxification.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="15">
                      <Accordion.Header>
                        <span>
                          Does Zenkify offer any discounts or packages for
                          regular Reiki Therapy clients?
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          Zenkify offers discounts and package deals for regular
                          Reiki Therapy clients, making it more accessible and
                          affordable for those who incorporate Reiki into their
                          wellness routine.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="16">
                      <Accordion.Header>
                        <span>
                          Can I learn Reiki techniques through Zenkify&apos;s
                          Reiki Therapy Services?
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          Yes, through Zenkify&apos;s Reiki Therapy Services,
                          you can indeed learn Reiki techniques. Our platform
                          hosts verified healers who offer courses in various
                          modalities, including Reiki. These courses are
                          designed to empower you to connect with your inner
                          self and practice self-care effectively. By enrolling
                          in these courses, you can learn Reiki techniques and
                          become certified, allowing you to incorporate this
                          healing practice into your life and potentially help
                          others as well.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="17">
                      <Accordion.Header>
                        <span>
                          What do clients say about their experiences with Reiki
                          Therapy at Zenkify?
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          At Zenkify, clients have shared positive experiences
                          about their Reiki Therapy sessions. Many have reported
                          feelings of relaxation, balance, and overall
                          well-being after their sessions. Clients often express
                          gratitude for the healing energy they receive and the
                          calming atmosphere created by the practitioners.
                        </p>
                        <p>
                          They appreciate the personalized approach of the
                          healers and how the sessions address their specific
                          concerns. Overall, feedback suggests that clients find
                          Reiki Therapy at Zenkify to be a beneficial and
                          transformative experience.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="18">
                      <Accordion.Header>
                        <span>
                          How can I contact Zenkify for more information about
                          their Reiki Therapy Services?
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          You can easily contact Zenkify for more information
                          about their Reiki Therapy Services USA through various
                          channels. You might want to visit our &quot;Contact
                          Us&quot; page where you can find email addresses,
                          phone numbers, or even a contact form to fill out.
                          Alternatively, if they have social media accounts, you
                          can send them a direct message or leave a comment
                          asking for information. Don&apos;t hesitate to reach
                          out - they&apos;re usually happy to provide more
                          details about reiki and healing services.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                  </>
                )}
              </Accordion>
            </Col>
          </Row>
        </Container>
      </section>
      <Link
        id="floatingBook"
        className="floating-book"
        aria-label="Book a FREE call now"
        href="/healers"
        style={{ opacity: showSideButton ? 1 : 0 }}
      >
        Book a FREE call now
      </Link>
    </>
  );
};

export default ReikiDetail;

ReikiDetail.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>;
};
